angular.module('swapick')
.controller('MessageCtrl', MessageCtrl);


function MessageCtrl($scope, DataService, $timeout,
  initialLoaderManager, $q, $ionicHistory, $state, $stateParams, Entities,
  $ionicScrollDelegate, notifyManager, $ionicLoading) {

  this.objects = [];
  this.offset = 0;
  this.meta = {};
  this.answering = false;
  this.newMessage = '';
  this.newConversation = false;
  this.destinatario = $stateParams.destinatario;
  this.messageSent = false;

  this.startAnswer = () => {
    this.answering = true;
    $timeout(()=>{
        document.querySelector("#message-answer").focus();
    })

  }

  this.stopAnswer = () => {
    this.answering = false;
    if(!this.message.id){
      return $ionicHistory.goBack();
    }
  }

  this.isMittente = (message) => {
    return !message.id || message.mittente.id == this.user.id;
  }

  this.sendNewMessage = () => {
   let target;
   if(this.isMittente(this.message)){
     target = this.message.destinatario.id;
   } else {
     target = this.message.mittente.id;
   }

   $ionicLoading.show();
   let newMessage = this.newMessage;
   DataService.messages.post({
     user_to : target,
     text : newMessage
   })
   .then((resp)=>{
     console.info(resp);
     this.messageSent = true;
     notifyManager.success("Messaggio inviato")
   })
   .finally(()=>{
     $ionicLoading.hide();
   })

  }

  this.loadMore = () => {
    this.loading = true;
    let other = this.isMittente(this.message) ? this.message.destinatario.id : this.message.mittente.id
    //call again dataservice and push to the list
    return DataService.messages.getList({
      limit:100, offset: this.offset,
      user: other.id })
    .then(items => {
      console.info(items, other)
      let newItems = _.filter(items,
        i=>{return i.mittente.id == other || i.destinatario.id == other})
      newItems = _.reject(newItems, i=>{return i.id >= this.message.id})
      this.offset += items.length;
      this.objects = this.objects.concat(newItems);
      this.meta = items.metadata;
      if(items.length){
        $ionicScrollDelegate.resize();
      }
      this.firstLoad = true;
      if(this.meta.next){
        return this.loadMore()
      }
      $timeout(()=>{
        $ionicScrollDelegate.scrollBottom()
      })
      return items;
    })
    .finally(()=>{
      this.loading = false;
    })
    $scope.$broadcast('scroll.infiniteScrollComplete');
  }

  this.hasMoreToLoad = () =>{
    return this.meta.next;
  }

  this.markAsRead = (msg) => {
    if(!msg.read){
        DataService.messages
        .one(this.message.id)
        .patch({read:true});
    }
    return msg;
  }


  this.loader = initialLoaderManager.makeLoader(()=>{

    return Entities.waitForUser()
    .then((u)=>{
        this.user = u;
        return u
    })
    .then((u)=>{
      if($stateParams.destinatario.id && ! $stateParams.messageId){
        this.message = {
          mittente : { id : this.user.id, nome : this.user.nome },
          destinatario : { id : $stateParams.destinatario.id,
            nome : $stateParams.destinatario.nome },
        }
        this.mittente = true
        this.markAsRead(this.message);
        return this.message;
      }

      if($stateParams.passedMessage && $stateParams.passedMessage.id == $stateParams.messageId){
        this.message = $stateParams.passedMessage;
        this.mittente = this.isMittente(this.message)
        this.markAsRead(this.message);
        return $stateParams.passedMessage;
      }
      return DataService.messages.one($stateParams.messageId)
      .get()
      .then((msg)=>{
        this.message = msg;
        this.mittente = this.isMittente(this.message);
        this.markAsRead(this.message);
        return msg;
      })

    })

  }, false);

  $scope.$on('$ionicView.beforeEnter', () => {
    this.loader.load();
  });



}



// WEBPACK FOOTER //
// ./src/controllers/message-controller.js